"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * A group for use in a Panorama.
         */
        var PanoramaItem = /** @class */ (function (_super) {
            __extends(PanoramaItem, _super);
            function PanoramaItem() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            PanoramaItem.prototype.init = function (data, element) {
                _super.prototype.init.call(this, data, element);
                this.LayoutArrangeMethod = $dyn.ui.autoProperty($dyn.layout.ArrangeMethod.horizontalWrap, this, "ArrangeMethod");
                this.LayoutColumns = $dyn.ui.columnsProperty($dyn.layout.Columns.fill, this);
            };
            /**
             * Gets the page header for this Panorama Item.
             */
            PanoramaItem.prototype.getHeader = function () {
                var panoramaItem = $(this.element);
                if (panoramaItem.length) {
                    return panoramaItem.find(".panoramaItem-title")[0];
                }
            };
            /**
             * Callback for when the container header is clicked.
             */
            PanoramaItem.prototype.HeaderClicked = function (evt) {
                $dyn.applyFunction(this.LabelAction, this);
            };
            /**
             * Handler for keyDown events
             * @param evt The keydown event that occurred.
             */
            PanoramaItem.prototype.keyDown = function (evt) {
                if (evt.which === $dyn.ui.KeyCodes.enter) {
                    this.HeaderClicked();
                    // Prevent the keyDown from bubbling so the form level enter shortcut is prevented.
                    // See documentation on this behavior in $dyn.ui.Control constructor.
                    evt.stopPropagation();
                    $dyn.log.stopPropagation && $dyn.log.stopPropagation("Prevent form level Enter shortcut.");
                }
            };
            return PanoramaItem;
        }($dyn.ui.Container));
        controls.PanoramaItem = PanoramaItem;
        PanoramaItem.prototype.Label = "";
        PanoramaItem.prototype.LabelAction = null;
        PanoramaItem.prototype.Width = $dyn.layout.Size.content;
        PanoramaItem.prototype.Height = $dyn.layout.Size.available;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=PanoramaItem.js.map
